import Button from "./Button";
export default Button;
export type { ButtonProps } from "./Button";

